import { JobPosition } from "../Model/JobPosition";


export class GetJobPositionsList {
    constructor(
      total,
      offset,
      limit,
      records,
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
      return new GetJobPositionsList(
        data.total,
        data.offset,
        data.limit,
        data.records.map((record) => {
          return JobPosition.createFromResponseData(record);
        }),
      );
    }
  };